import { Box, Button, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useTranslation } from 'react-i18next'
import { useUpdateKybPersonMutation } from '../../../services/guenoApi'

const KybPersonRemoveManualAddress = ({ initialValue, onConfirm, onCancel }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [_, { isLoading }] = useUpdateKybPersonMutation({ fixedCacheKey: 'update-subject' })

  return (
    <>
      <Box className="modal-box">
        <Typography>{t('messages:kyb.manualAddress.delete')}</Typography>
        <Typography>{initialValue}</Typography>
      </Box>
      <Box className="modal-button">
        <Button size="small" color="error" variant="outlined" onClick={onCancel}>
          {t('common:cancel')}
        </Button>
        <LoadingButton size="small" color="secondary" variant="contained" onClick={onConfirm} loading={isLoading}>
          {t('common:delete')}
        </LoadingButton>
      </Box>
    </>
  )
}

export default KybPersonRemoveManualAddress
